<template>
  <el-popover
    placement="bottom"
    width="800"
    trigger="click"
    v-model="visible"
    popper-class="dg-api-el-popover"
    >
    <dg-table
      ref="popoverApiTable"
      apiCode="sysApiList"
      row-key="API_CODE"
      :toolbarItems="tableModel.toolbarItems"
      :border="true"
      :tableItems="tableModel.tableItems"
      @rowClick="rowClick"
      @rowDblclick="rowClick"
      >
    </dg-table>
    <el-input
      slot="reference" 
      v-model="innerValue"
      v-cleaveEl="cleave || { notCleave: true }"
      type="text"
      :size="size || 'mini'"
      :style="Dgstyle"
      :maxlength="maxlength"
      :autosize="autosize"
      :prefix-icon="prefixIcon"
      :suffix-icon="suffixIcon"
      :readonly="readonly"
      :placeholder="placeholder || (disabled ? '' : '请输入')"
      :disabled="disabled"
      :clearable="true"
      @clear="clearInput"
    >
      <template v-if="prepend" slot="prepend"
        ><span>{{ prepend }}</span></template
      >
      <template v-if="append" slot="append"
        ><span>{{ append }}</span></template
      >
    </el-input>
  </el-popover>
</template>
<script lang="jsx">
export default {
  name: 'DgApiSelect',
  props: {
    /* 初始值 */
    value: {
      default: () => {
        return null
      },
    },
    cleave: {
      type: String,
      default: () => '',
    },
    size: {
      type: String,
      default: () => '',
    },
    maxlength: {
      type: String,
      default: () => '',
    },
    autosize: {
      default: () => {
        return null
      },
    },
    prefixIcon: {
      type: String,
      default: () => '',
    },
    suffixIcon: {
      type: String,
      default: () => '',
    },
    prepend: {
      type: String,
      default: () => '',
    },
    append: {
      type: String,
      default: () => '',
    },
    Dgstyle: {
      type: String,
      default: () => '',
    },
    placeholder: {
      type: String,
      default: () => '',
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      visible: false,
      tableModel: {
        toolbarItems: [
          { value: 'API_CODE', editer: 'input', placeholder: 'API编码' },
          { value: 'API_NAME', editer: 'input', placeholder: 'API名称' },
          { value: 'TBNAME', editer: 'input', placeholder: '相关表名' }
        ],
        tableItems: [
          { title: 'API编码', field: 'API_CODE', width: 100 },
          { title: 'API名称', field: 'API_NAME', width: 100 },
          { title: '相关表名', field: 'TBNAME', width: 120 },
          { title: '主键字段', field: 'KEYFIELD', width: 120 },
          { title: 'SQL模板', field: 'SQL_TEMPLATE', width: 120 },
          { title: '服务描述', field: 'DESCRIPTION'},
          { title: '服务参数', field: 'PARA'},
        ]
      }
    }
  },
  created () {
    console.log(this.item,'item prop')
  },
  computed: {
    innerValue: {
      get() {
        this.updateValue(this.value)
        return this.formatValue(this.value)
      },
      set(val) {
        this.$emit('input', this.formatValue(val),this.item)
      },
    },
  },
  methods: {
    clearInput() {
      this.visible = false
      this.updateValue('')
    },
    rowClick(row) {
      this.visible = false
      this.updateValue(row.API_CODE)
    },
    formatValue(val) {
      // 格式化？
      return val
    },
    updateValue(val) {
      this.$emit('updateValue', this.formatValue(val))
    },
  },
}
</script>
